import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Target, Eye, HeartHandshake } from "lucide-react";
import api, { DEFAULT_AVATAR } from "@/lib/api";

export default function About() {
  const [leaders, setLeaders] = useState([]);
  useEffect(() => { api.get("/content/leadership").then((r) => setLeaders(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="topo-bg text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <span className="eyebrow text-secondary">About Us</span>
          <h1 className="font-heading font-black text-4xl md:text-5xl mt-3">The Movement's Mission</h1>
          <p className="mt-4 text-lg text-emerald-50 max-w-2xl">
            The London Boy Movement is a statewide grassroots mobilisation force built to give the people of
            Nasarawa an organised, transparent and unstoppable platform for change.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-6">
        {[
          [Eye, "Our Vision", "A united Nasarawa where every ward is empowered, every voice counts, and development reaches the grassroots."],
          [Target, "Our Mission", "To mobilise, educate and organise supporters down to the polling unit, championing Sen. Wadada's vision of accountability and empowerment."],
          [HeartHandshake, "Our Values", "Transparency, service, unity and relentless grassroots commitment across all 13 LGAs."],
        ].map(([Icon, t, d], i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
            className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8">
            <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center mb-4"><Icon className="w-6 h-6 text-primary" /></div>
            <h3 className="font-heading font-bold text-xl">{t}</h3>
            <p className="mt-2 text-muted-foreground leading-relaxed">{d}</p>
          </motion.div>
        ))}
      </section>

      <section className="bg-muted/50 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="eyebrow">Leadership</span>
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl mt-2">Meet the Leadership</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {leaders.map((l, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                data-testid={`leader-card-${i}`}
                className="bg-white rounded-3xl overflow-hidden shadow-xl border border-slate-100 group hover:shadow-2xl transition-all">
                <div className="aspect-[4/3] overflow-hidden bg-muted flex items-center justify-center">
                  <img src={DEFAULT_AVATAR} alt={l.name} className="w-full h-full object-cover opacity-90" />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase text-primary font-bold tracking-wide">{l.role}</div>
                  <h3 className="font-heading font-extrabold text-xl mt-1">{l.name}</h3>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{l.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
